import { gql } from '@apollo/client';

export const CREATE_SOURCE_AREA_PROCESS = gql`
    mutation CreateSourceAreaProcess($input: CreateSourceAreaProcess!) {
        facility {
            process {
                createSourceAreaProcess(input: $input) {
                    id
                }
            }
        }
    }
`;
